export const groupTicketKeys = {
    all: ['groupTicket'] as const,
    list: (centerId: string) => ['groupTicket', 'list', centerId] as const,
    memberList: (centerId: string, memberId: string) => ['groupTicket', 'member', centerId, memberId] as const,
    centerList: (centerId: string) => ['groupTicket', 'center', centerId] as const,
    bookableSessions: (centerId: string, memberTicketId: string) => ['groupTicket', 'bookableSessions', centerId, memberTicketId] as const,
};
